module.exports = __webpack_public_path__ + "static/plv-21cbbaa7a085b22fa39d76edff52edab.jpg";